import { EolStatus } from '@gonfalon/openapi/types';

// SDK Status enum for frontend display
export enum SDKStatus {
  UP_TO_DATE = 'Up to date',
  MAJOR_VERSION_AVAILABLE = 'Major version available',
  EOL_APPROACHING = 'End of life approaching',
  OUT_OF_DATE = 'No longer supported',
  UNKNOWN = 'Status undetermined',
}

// Re-export EolStatus for convenience
export { EolStatus };

// Map backend EOL status to frontend display status
export const mapEolStatusToStatus = (eolStatus: EolStatus | undefined): SDKStatus => {
  if (!eolStatus || eolStatus === EolStatus.UNKNOWN) {
    return SDKStatus.UNKNOWN;
  }
  if (eolStatus === EolStatus.ALL_CLEAR) {
    return SDKStatus.UP_TO_DATE;
  }
  if (eolStatus === EolStatus.MAJOR_VERSION_AVAILABLE) {
    return SDKStatus.MAJOR_VERSION_AVAILABLE;
  }
  if (eolStatus === EolStatus.EOL_NEAR || eolStatus === EolStatus.EOL_APPROACHING) {
    return SDKStatus.EOL_APPROACHING;
  }
  if (eolStatus === EolStatus.EOL_PAST || eolStatus === EolStatus.DEPRECATED) {
    return SDKStatus.OUT_OF_DATE;
  }
  return SDKStatus.UNKNOWN;
};

// Map SDK status to Launchpad Tag variant
export const getStatusTagVariant = (status: SDKStatus): 'success' | 'info' | 'warning' | 'error' | 'default' => {
  switch (status) {
    case SDKStatus.UP_TO_DATE:
      return 'success';
    case SDKStatus.MAJOR_VERSION_AVAILABLE:
      return 'info';
    case SDKStatus.EOL_APPROACHING:
      return 'warning';
    case SDKStatus.OUT_OF_DATE:
      return 'error';
    case SDKStatus.UNKNOWN:
      return 'default';
    default:
      return 'default';
  }
};

// Connection type enum
export enum ConnectionType {
  DIRECT = 'Direct',
  RELAY_PROXY = 'Relay Proxy',
}

// SDK Types
export enum SDKType {
  CLIENT_SIDE = 'Client-side',
  SERVER_SIDE = 'Server-side',
  MOBILE = 'Mobile',
}

// Sort fields
export enum SortField {
  APPLICATION = 'application',
  CONNECTED_SDKS = 'connectedSdks',
  STATUS = 'status',
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

// Shared interface for SDK connection details
export interface SDKConnection {
  id: string;
  projectId: string;
  environmentId: string;
  sdkName: string;
  sdkType: SDKType | string;
  sdkVersion: string;
  connectionType: ConnectionType | string;
  relayVersion: string;
  status: SDKStatus;
  eolStatus: EolStatus | undefined;
  latestVersion?: string;
  latestReleaseUrl?: string;
}

// Shared interface for SDK data (list view)
export interface SDKData {
  id: string;
  application: string;
  connectedSdks: string[];
  status: SDKStatus;
}
